import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import cancelarSeguroReserva from '../../actions/reserva/cancelarSeguroReserva';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoCancelamentoSeguro extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoSeguro')
      .modal('hide');
    $('#modalConfirmacaoCancelamentoSeguro')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.cancelarSeguroReserva(this.props.empresaSelecionada.id, values.observacao, this.props.reservas.filter(f => f.selecionada)
      .map(it => it.id))
      .then(() => {
          showSuccessMsg('Seguros cancelados com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirValorCancelamento () {
    let estorno = 0.00;
    if (this.props.reservas && this.props.reservas.filter(f => f.selecionada).length > 0) {
      this.props.reservas.filter(f => f.selecionada)
        .forEach(reserva => {
          estorno += Number(reserva.tarifaSeguro);
        })
    }

    return <div className="form-row ml-2">
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Estorno:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {estorno
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
    </div>

  }

  exibirReservas () {
    return <div className='mt-4 ml-2'>
      Reservas:
      <ul>
        {this.props.reservas.filter(f => f.selecionada)
          .map(reserva => <React.Fragment key={reserva.id}>
            <li>{reserva.descCidadeOrigem} -&gt; {reserva.descCidadeDestino}: {reserva.passageiroDto.nome}</li>
          </React.Fragment>)}
      </ul>
    </div>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoSeguro" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoSeguro" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada)
                  ?
                  <React.Fragment>
                    {this.exibirValorCancelamento()}
                    {this.exibirReservas()}
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea} max={1500} validate={[required]} className="form-control" label="Motivo do cancelamento:"/>
                  </React.Fragment>
                  : ''}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarSeguroReserva
})(reduxForm({
  form: 'formularioCancelamentoSeguro',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoSeguro));
